(function () {
  function initBrandSearch(search) {
    if (!search || search.dataset.initialized === 'true') {
      return;
    }

    search.dataset.initialized = 'true';

    var input = search.querySelector('.ns-villkor__search-input');
    var clearButton = search.querySelector('[data-brand-clear]');
    var panel = search.querySelector('[data-brand-panel]');
    var suggestions = search.querySelector('.ns-villkor__suggestions');
    var result = search.querySelector('[data-brand-result]');
    var liveRegion = search.querySelector('.ns-villkor__sr-only');
    var brandsUrl = search.getAttribute('data-brands-url') || search.getAttribute('data-brand-url');
    var brandSearchSection = search.closest('.ns-villkor__section') || search;
    var sectionId = search.getAttribute('data-section-id') || 'section';
    var activeIndex = -1;
    var entries = [];
    var approvedMap = new Map();
    var restrictedMap = new Map();
    var rejectedMap = new Map();

    var statusConfig = {
      approved: {
        title: 'Godkänt varumärke',
        text: 'Detta varumärke passar normalt vårt sortiment. Slutlig bedömning görs alltid utifrån skick, modell, säsong och aktuell efterfrågan.',
        modifier: 'approved'
      },
      restricted: {
        title: 'Endast utvalda artiklar',
        text: 'Vi tar endast emot utvalda artiklar från detta varumärke. Skick, modell och aktuell efterfrågan avgör.',
        modifier: 'restricted'
      },
      rejected: {
        title: 'Vi tar inte emot detta varumärke',
        text: 'Detta varumärke ingår inte i vårt sortiment för inlämning.',
        modifier: 'rejected'
      },
      unknown: {
        title: 'Varumärket finns inte i listan',
        text: 'Kontakta oss gärna eller besök butiken för en bedömning.',
        modifier: 'unknown'
      }
    };

    if (!input || !clearButton || !panel || !suggestions || !result || !brandsUrl) {
      return;
    }

    function normalizeBrand(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function normalize(value) {
      return normalizeBrand(value);
    }

    function escapeHtml(value) {
      return (value || '').toString()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function setLiveMessage(message) {
      if (liveRegion) {
        liveRegion.textContent = message;
      }
    }

    function setExpanded(isExpanded) {
      input.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    function isMobileViewport() {
      return window.innerWidth < 750;
    }

    function syncPanelVisibility() {
      var hasSuggestions = !suggestions.hidden && suggestions.children.length > 0;
      panel.hidden = !hasSuggestions;
    }

    function clearSuggestions() {
      activeIndex = -1;
      suggestions.innerHTML = '';
      suggestions.hidden = true;
      setExpanded(false);
      input.removeAttribute('aria-activedescendant');
      syncPanelVisibility();
    }

    function renderResultCard(html, modifier) {
      result.hidden = false;
      result.className = 'ns-villkor__brand-result' + (modifier ? ' ns-villkor__brand-result--' + modifier : '');
      result.innerHTML = html;
      syncPanelVisibility();
    }

    function getExactEntry(query) {
      var normalizedQuery = normalize(query);

      if (!normalizedQuery) {
        return null;
      }

      if (approvedMap.has(normalizedQuery)) {
        return {
          name: approvedMap.get(normalizedQuery),
          normalized: normalizedQuery,
          status: 'approved'
        };
      }

      if (restrictedMap.has(normalizedQuery)) {
        return {
          name: restrictedMap.get(normalizedQuery),
          normalized: normalizedQuery,
          status: 'restricted'
        };
      }

      if (rejectedMap.has(normalizedQuery)) {
        return {
          name: rejectedMap.get(normalizedQuery),
          normalized: normalizedQuery,
          status: 'rejected'
        };
      }

      return null;
    }

    function showResultForEntry(entry) {
      var config = statusConfig[entry.status];

      if (!config) {
        return;
      }

      renderResultCard(
        '<div class="ns-villkor__brand-result-inner">' +
          '<p class="ns-villkor__brand-result-label">' + config.title + '</p>' +
          '<h3 class="ns-villkor__brand-result-name">' + escapeHtml(entry.name) + '</h3>' +
          '<p class="ns-villkor__brand-result-text">' + config.text + '</p>' +
        '</div>',
        config.modifier
      );
      setLiveMessage(entry.name + '. ' + config.title + '.');
    }

    function showNoMatch() {
      var config = statusConfig.unknown;

      renderResultCard(
        '<div class="ns-villkor__brand-result-inner">' +
          '<p class="ns-villkor__brand-result-label">' + config.title + '</p>' +
          '<p class="ns-villkor__brand-result-text">' + config.text + '</p>' +
        '</div>',
        config.modifier
      );
      setLiveMessage(config.title + '.');
    }

    function showError() {
      renderResultCard(
        '<div class="ns-villkor__brand-result-inner">' +
          '<p class="ns-villkor__brand-result-label">Kunde inte ladda listan</p>' +
          '<p class="ns-villkor__brand-result-text">Varumärkeslistan kunde inte laddas just nu. Försök igen senare eller kontakta oss.</p>' +
        '</div>',
        'error'
      );
      setLiveMessage('Varumärkeslistan kunde inte laddas.');
    }

    function updateActiveSuggestion() {
      var options = suggestions.querySelectorAll('[role="option"]');

      options.forEach(function (option, index) {
        var isActive = index === activeIndex;
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
        option.classList.toggle('is-active', isActive);

        if (isActive) {
          input.setAttribute('aria-activedescendant', option.id);
        }
      });

      if (activeIndex < 0) {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function selectEntry(entry) {
      var exactEntry = getExactEntry(entry.name) || entry;

      input.value = exactEntry.name;
      clearButton.hidden = false;
      clearSuggestions();
      showResultForEntry(exactEntry);
    }

    function buildSuggestions(matches) {
      clearSuggestions();

      if (!matches.length) {
        return;
      }

      var fragment = document.createDocumentFragment();

      matches.forEach(function (entry, index) {
        var item = document.createElement('li');
        var button = document.createElement('button');
        var config = statusConfig[entry.status];

        item.className = 'ns-villkor__suggestion-item';
        button.type = 'button';
        button.id = 'ns-brand-option-' + sectionId + '-' + index;
        button.className = 'ns-brand-suggestion ns-villkor__brand-suggestion ns-villkor__suggestion';
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', 'false');
        button.innerHTML =
          '<span class="ns-villkor__suggestion-name">' + escapeHtml(entry.name) + '</span>' +
          '<span class="ns-villkor__suggestion-status">' + config.title + '</span>';

        button.addEventListener('click', function () {
          selectEntry(entry);
        });

        item.appendChild(button);
        fragment.appendChild(item);
      });

      suggestions.appendChild(fragment);
      suggestions.hidden = false;
      setExpanded(true);
      setLiveMessage(matches.length + ' förslag tillgängliga.');
      syncPanelVisibility();
    }

    function getMatches(query) {
      var normalizedQuery = normalize(query);

      if (!normalizedQuery) {
        return [];
      }

      return entries
        .filter(function (entry) {
          return entry.normalized.indexOf(normalizedQuery) !== -1;
        })
        .sort(function (a, b) {
          var aStarts = a.normalized.indexOf(normalizedQuery) === 0 ? 0 : 1;
          var bStarts = b.normalized.indexOf(normalizedQuery) === 0 ? 0 : 1;

          if (aStarts !== bStarts) {
            return aStarts - bStarts;
          }

          return a.name.localeCompare(b.name, 'sv');
        })
        .slice(0, 8);
    }

    function handleInput() {
      var query = input.value;
      var normalizedQuery = normalize(query);
      var hasEnoughCharacters = normalizedQuery.length >= 2;
      var matches = hasEnoughCharacters ? getMatches(query) : [];

      clearButton.hidden = !normalizedQuery;

      if (!normalizedQuery) {
        clearSuggestions();
        result.hidden = true;
        result.className = 'ns-villkor__brand-result';
        result.innerHTML = '';
        setLiveMessage('');
        syncPanelVisibility();
        return;
      }

      if (hasEnoughCharacters) {
        buildSuggestions(matches);
      } else {
        clearSuggestions();
        setLiveMessage('');
      }

      result.hidden = true;
      result.className = 'ns-villkor__brand-result';
      result.innerHTML = '';
      syncPanelVisibility();
    }

    function handleKeydown(event) {
      var options = suggestions.querySelectorAll('[role="option"]');

      if (event.key === 'ArrowDown' && options.length) {
        event.preventDefault();
        activeIndex = activeIndex < options.length - 1 ? activeIndex + 1 : 0;
        updateActiveSuggestion();
        return;
      }

      if (event.key === 'ArrowUp' && options.length) {
        event.preventDefault();
        activeIndex = activeIndex > 0 ? activeIndex - 1 : options.length - 1;
        updateActiveSuggestion();
        return;
      }

      if (event.key === 'Enter') {
        if (activeIndex >= 0 && options[activeIndex]) {
          event.preventDefault();
          options[activeIndex].click();
          return;
        }

        if (normalize(input.value)) {
          event.preventDefault();

          var exactEntry = getExactEntry(input.value);

          clearSuggestions();

          if (exactEntry) {
            input.value = exactEntry.name;
            showResultForEntry(exactEntry);
          } else {
            showNoMatch();
          }
        }
      }

      if (event.key === 'Escape') {
        clearSuggestions();
      }
    }

    function registerBrands(status, brands, targetMap, seen) {
      brands.forEach(function (name) {
        var normalizedName = normalize(name);

        if (!normalizedName || seen.has(normalizedName)) {
          return;
        }

        seen.add(normalizedName);
        targetMap.set(normalizedName, name);
        entries.push({
          name: name,
          normalized: normalizedName,
          status: status
        });
      });
    }

    function prepareEntries(payload) {
      var seen = new Set();

      entries = [];
      approvedMap = new Map();
      restrictedMap = new Map();
      rejectedMap = new Map();

      registerBrands('approved', Array.isArray(payload.approved) ? payload.approved : [], approvedMap, seen);
      registerBrands('restricted', Array.isArray(payload.restricted) ? payload.restricted : [], restrictedMap, seen);
      registerBrands('rejected', Array.isArray(payload.rejected) ? payload.rejected : [], rejectedMap, seen);
    }

    clearButton.addEventListener('click', function () {
      input.value = '';
      clearButton.hidden = true;
      clearSuggestions();
      result.hidden = true;
      result.className = 'ns-villkor__brand-result';
      result.innerHTML = '';
      setLiveMessage('');
      syncPanelVisibility();
      input.focus();
    });

    input.addEventListener('input', handleInput);
    input.addEventListener('keydown', handleKeydown);
    input.addEventListener('focus', function () {
      if (isMobileViewport()) {
        window.setTimeout(function () {
          var rect = brandSearchSection.getBoundingClientRect();
          var targetY = window.pageYOffset + rect.top - 90;
          window.scrollTo({ top: Math.max(targetY, 0), behavior: 'smooth' });
        }, 250);
      }
    });
    input.addEventListener('blur', function () {
      window.setTimeout(function () {
        clearSuggestions();
      }, 120);
    });

    window.addEventListener('resize', syncPanelVisibility);

    fetch(brandsUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Brand asset request failed.');
        }

        return response.json();
      })
      .then(function (payload) {
        prepareEntries(payload || {});
      })
      .catch(function () {
        clearSuggestions();
        showError();
      });
  }

  function initAll(context) {
    var scope = context || document;
    var searches = scope.querySelectorAll('[data-ns-inlamningstips] [data-brand-search]');

    searches.forEach(initBrandSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
